import dayjs from 'dayjs';
import 'dayjs/locale/pt-br';

dayjs.locale('pt-br');

export function formatDate(iso?: string | null): string {
    if (!iso) {
        return '—';
    }
    return dayjs(iso).format('DD/MM/YYYY HH:mm');
}

export function formatDateShort(iso?: string | null): string {
    if (!iso) {
        return '—';
    }
    return dayjs(iso).format('DD/MM/YYYY');
}

export type TranslateFn = (key: string, options?: Record<string, unknown>) => string;

export function formatRelative(iso: string, t: TranslateFn): string {
    const diff = Date.now() - new Date(iso).getTime();
    const m = Math.floor(diff / 60000);
    if (m < 1) {
        return t('common.justNow');
    }
    if (m < 60) {
        return t('common.minutesAgo', { count: m });
    }
    const h = Math.floor(m / 60);
    if (h < 24) {
        return t('common.hoursAgo', { count: h });
    }
    const d = Math.floor(h / 24);
    if (d === 1) {
        return t('common.yesterday');
    }
    if (d < 7) {
        return t('common.daysAgo', { count: d });
    }
    return dayjs(iso).format('DD/MM/YYYY');
}
